module.exports = __webpack_public_path__ + "img/book-font.22783b55.svg";